import notifications from './notification';
import snackbar from './snackbar';

export default {
  notifications,
  snackbar,
};
